import React, { forwardRef } from 'react';
import { InputPhoneContainer, InputPhoneLabel, InputPhoneArea, InputPhoneGroup, InputPhoneField, InputPhoneMessageError } from './styles';
import InputMask from 'react-input-mask';

const InputPhone = forwardRef((props, fwRef) => {
  return (
    <InputPhoneContainer id="input-phone">
      <InputPhoneLabel htmlFor={props.id}>{props.label}</InputPhoneLabel>
      <InputPhoneGroup readOnly={props.readOnly} className={props.error && 'error'}>
        <InputPhoneArea>+57</InputPhoneArea>
        <InputPhoneField
          type="text"  // Asegúrate de que el tipo sea "text"
          id={props.id}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onClick={props.onClick}
          className={props.error && 'error'}
          readOnly={props.readOnly}
          autoComplete="off"
        />
      </InputPhoneGroup>
      {props.error && <InputPhoneMessageError error={props.error}>{props.error.message}</InputPhoneMessageError>}
    </InputPhoneContainer>
  )
})

export default InputPhone
